
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m9.476 2.4-6.521 2.639.491 7.015 6.824 1.7 3.73-5.962Z","stroke-linejoin":"round","stroke-width":"2"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  